import React, { Fragment, useState } from 'react';

import { format, /*parseISO*/ } from 'date-fns';
import ja from 'date-fns/locale/ja'

import { Box, AppBar, IconButton, Typography, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, FormGroup, Switch, Toolbar, FormControl, RadioGroup, Radio, Divider, TextField, Menu, MenuItem } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
import { DatePicker } from '@mui/x-date-pickers';
import { AccountCircle, ArrowCircleLeft, ArrowCircleRight, Cached, Clear, Help, Person, Print } from '@mui/icons-material';

import { useSnackbar } from 'notistack';

import './ReserveTable.css';
import { useAjax } from './Ajax';
import { useCommService } from './WebSocket';
import { useAuth } from './AuthContext';
import { PasswordDialog } from './StaffMaster';

// ----------

const weekdayColor = (data) => (
    (
        data.holiday ? 'holiday':
        data.weekday==='日' ? 'sun' :
        data.weekday==='土' ? 'sat' : ''
    ) + (
        (data.emerge ? ' emerge' : '')
    )
)

// const weekdayYellow = (data) => (
//     ('土日月'.indexOf(data.weekday)<0)?' yellow':''
// )
const asbestosHeader = (date) => (
    ([1, 2, 7, 8].includes(date.getMonth()+1) ? '月・金 6 名 / 火・水 8 名 / 木 なし' : '月・火・水・金 8 名 / 木 3 名')
)
const nigiColor = (data) => (
    (data.date.getMonth()+1>=4 && data.date.getMonth()+1<=9 ? '' : 'red')
)
const seasonClose = (data) => (
    (data.date.getMonth()+1>=4 && data.date.getMonth()+1<=9 ? '' : 'close')
)
const asbestosClose = (data) => (
    (![1, 2, 7, 8].includes(data.date.getMonth()+1) ? '' : 'close')
)
const asbestosOpen = (data) => (
    ([1, 2, 7, 8].includes(data.date.getMonth()+1) ? '' : 'close')
)
const asbestosOpen3 = (data) => (
    ([1, 2, 7, 8].includes(data.date.getMonth()+1) ? 'green' : '')
)
const asbestosOpen3a = (data) => (
    // ([1, 2, 7, 8].includes(data.date.getMonth()+1) ? (['木'].includes(data.weekday) ? 'close': 'green') : '')
    ([1, 2, 7, 8].includes(data.date.getMonth()+1) ? (['木'].includes(data.weekday) ? 'green'/*'close'*/: 'green') : '')
)
const asbestosTWOpen = (data) => (
    // ([1, 2, 7, 8].includes(data.date.getMonth()+1) ? (['火', '水'].includes(data.weekday) ? '': 'close') : '')
    (data.holiday || data.weekday==='土' || data.weekday==='日')?'close':''
)
const asbestosTWOpen2 = (data) => (
    ([1, 2, 7, 8].includes(data.date.getMonth()+1) ? (['火', '水'].includes(data.weekday) ? '': 'blue') : '')
)
const asbestosTWOpen3 = (data) => (
    // ([1, 2, 7, 8].includes(data.date.getMonth()+1) ? (['月', '金'].includes(data.weekday) ? 'blue': (['木'].includes(data.weekday) ? 'close': 'green')) : '')
    ([1, 2, 7, 8].includes(data.date.getMonth()+1) ? (['月', '金'].includes(data.weekday) ? 'blue': (['木'].includes(data.weekday) ? 'green'/*'close'*/: 'green')) : '')
)

const tuefri2thuClose = (data) => (
    (data.holiday || data.weekday==='火' || data.thu2nd || data.weekday==='金' || data.weekday==='土' || data.weekday==='日')?'close':''
)
const weekdayClose = (data) => (
    (data.holiday || data.weekday==='土' || data.weekday==='日')?'close':''
)
const tueClose = (data) => (
    (data.holiday || data.weekday==='火' || data.weekday==='土' || data.weekday==='日')?'close':''
)
const monClose = (data) => (
    (data.holiday || data.weekday==='月' || data.weekday==='土' || data.weekday==='日')?'close':''
)
const montueClose = (data) => (
    (data.holiday || data.weekday==='月' || data.weekday==='火' || data.weekday==='土' || data.weekday==='日')?'close':''
)
const thuClose = (data) => (
    // (data.holiday || data.weekday==='木' || data.weekday==='土' || data.weekday==='日')?'close':''
    (data.holiday || data.weekday==='土' || data.weekday==='日')?'close':''
)
const tuethufriClose = (data) => (
    (data.holiday || data.weekday==='火' || data.weekday==='木' || data.weekday==='金' || data.weekday==='土' || data.weekday==='日')?'close':''
)
const tuefriClose = (data) => (
    (data.holiday || data.weekday==='火' || data.weekday==='金' || data.weekday==='土' || data.weekday==='日')?'close':''
)
const tuethuClose = (data) => (
    (data.holiday || data.weekday==='火' || data.weekday==='木' || data.weekday==='土' || data.weekday==='日')?'close':''
)
const thursdayClose = (data) => (
    (data.holiday || data.weekday==='木' || data.weekday==='土' || data.weekday==='日')?'close':''
)
const fridayClose = (data) => (
    (data.holiday || data.weekday==='金' || data.weekday==='土' || data.weekday==='日')?'close':''
)
const tuesdayOpen = (data) => (
    (data.weekday!=='火' )?'close':''
)
const tuethuOpen = (data) => (
    (data.holiday || '火木'.indexOf(data.weekday)<0)?'close':''
)


// const tuethuClose = (data) => (
//     ('月水金'.indexOf(data.weekday)<0)?'':'close'
// )
const monfriClose = (data) => (
    (data.holiday || data.weekday==='月' || data.weekday==='金' || data.weekday==='土' || data.weekday==='日')?'close':''
)

// ----------

// const emergentClose = (data) => (
//     (data.holiday || data.emerge || data.weekday==='土' || data.weekday==='日')?'close':''
// )
const emergentAndNext234Close = (data) => (
    (data.holiday || data.emerge || data.emergeNext || data.weekday==='火' || data.weekday==='水' || data.weekday==='木' || data.weekday==='土' || data.weekday==='日')?'close':''
)
const emergentAndNext24Close = (data) => (
    (data.holiday || data.emerge || data.emergeNext || data.weekday==='火' || data.weekday==='木' || data.weekday==='土' || data.weekday==='日')?'close':''
)
const emergentAndNextClose = (data) => (
    (data.holiday || data.emerge || data.emergeNext || data.weekday==='土' || data.weekday==='日')?'close':''
)
const emergentNextClose = (data) => (
    (data.holiday || data.emergeNext || data.weekday==='土' || data.weekday==='日')?'close':''
)

// ----------

const valCheck = (item, waku) =>  {
    if(!item) return null;
    const cnt_normal  = item[`${waku}_check`] || 0;
    const cnt_dock    = item[`${waku}_dock`] || 0;
    const cnt_special = item[`${waku}_special`] || 0; /* 20241031 */
    const cnt_asbestos = item[`${waku}_asbestos`] || 0; /* 20250122 */

    const _color = ['1','2','3','4','5','6','7','8', '9','a','b','c', 'd','e','f','g','h','i','j'].map(i => {
        if ( (item[`${waku}_c${i}`] || 0 ) > 0 ) {
            return `c${i}`;
        };
        return null;
    });
    const color = _color.join(' ').trim();

    if (cnt_normal+cnt_dock+cnt_special+cnt_asbestos > 1) return <span className='error'>{cnt_normal+cnt_dock+cnt_special+cnt_asbestos}</span>; /* 20241031 20250122 */
    if (cnt_normal+cnt_dock+cnt_special+cnt_asbestos === 0) return <span className='check'>&nbsp;</span>; /* 20241031 20250122 */

    // const mark = (cnt_normal>0) ? '✔' : ((cnt_dock>0) ? 'ド' : '特'); /* 20241031 */
    const mark = (cnt_normal>0) ? '✔' : ((cnt_dock>0) ? 'ド' : ((cnt_special>0) ? '特' : 'ア')); /* 20250122 */
    // const mark = (cnt_normal>0) ? '✔' : 'ド'; /* 20241031 */
    // const [disp, style, title] = item[`${waku}_memo`] ? [item[`${waku}_memo`].replaceAll('　', ' ').split(' ').map((v,i)=>(<React.Fragment key={i}>{v}<br/></React.Fragment>)), 'memo', item[`${waku}_memo`]] : [mark, '', mark];
    const [disp, style, title] = item[`${waku}_memo`] ? [mark, '', item[`${waku}_memo`]] : [mark, '', mark];

    // console.log(color.join(' ').trim());

    return <span className={`check ${style} ${color}`} title={title}>{disp}</span>;
}

// const valCheck = (item, waku) =>  {
//     const cnt_normal = item[`${waku}_check`] || 0;
//     const cnt_red    = item[`${waku}_checkRed`] || 0;

//     if (cnt_normal+cnt_red > 1) return <span className='error'>{cnt_normal+cnt_red}</span>;
//     if (cnt_normal+cnt_red === 0) return <span className='check'>&nbsp;</span>;
//     // console.log(item);
//     const [disp, style] = item[`${waku}_memo`] ? [item[`${waku}_memo`], 'memo'] : ['✔', ''];
//     return (cnt_normal===1)?<span className={`check ${style}`} title={disp}>{disp}</span>:<span className={`check redcheck ${style}`} title={disp}>{disp}</span>;
// }

const valClose = (item, waku) => {
    const cnt_close = item[`${waku}_close`] || 0;

    return (cnt_close >= 1) ? ' close' : '';
}

const getActionString = (action) => {
    switch(action) {
        case 'OPEN': return '枠を開けました';
        case 'CLOSE': return '枠を閉じました';
        case 'UNCHECK': return '予約解除しました';
        case 'RESET': return '重複をリセットしました';
        case 'LOGIN': return 'ログインしました';
        case 'LOGOUT': return 'ログアウトしました';
        case 'CHECK':
        default: return '予約しました';
    }
}
const getWakuString = (waku) => {
    switch(waku[0]) {
        case 'A': return "診察";
        case 'B': return "Mg X-P";
        case 'C': return "胃カメラ";
        case 'D': return "胃 単独";
        case 'E': return "胃検査なし";
        case 'F': return "特定健診";
        case 'G': return "エコー";
        case 'H': return "子宮がん健診";
        case 'I': return "乳がん検診";
        case 'J': return "心臓ドック";
        case 'K': return "脳ドック";
        case 'V': return "午後診察";
        case 'W': return "職員健診";
        default: return "";
    }
}
// ==========

const getDays = (date, day) => {
    const year = date.getFullYear()
    const month = date.getMonth()

    const days = []

    for(let i=1; i<=31; i++) {
        const tmpDate = new Date(year, month, i)
        if(month!==tmpDate.getMonth()) break
        if (tmpDate.getDay() !== day) continue

        days.push(tmpDate.getDate())
    }
    return days
}

// ==========

var handleClickWakuF = false;

const ReserveTale = () => {
    const { enqueueSnackbar } = useSnackbar();
    const { getEvents, getChecks, wakuOpen, wakuClose, wakuCheck, wakuUncheck } = useAjax();
    const { state:authState, logoff, modeMaster, modeAm, modePm } = useAuth(); /* 20241031 */

    const [entryName, setEntryName] = useState("")


    const appBarRef = React.useRef(null);
    const tableWrapRef = React.useRef(null);

    document.title = "健診予約表";
    // ----------

    // const webSocketRef = React.useRef();
    // useEffect(() => {
    //     const socket = new WebSocket("ws:localhost:3001/provider");
    //     webSocketRef.current = socket;

    //     socket.addEventListener('message', event => {
    //         console.log(JSON.parse(event.data));
    //     });

    //     return () => {
    //         socket.close();
    //         webSocketRef.current = null;
    //     }
    // }, []);

    // ----------

    const [date, setDate] = React.useState(null);
    React.useEffect(() => {
        // setDate(parseISO('2022-12-01T00:00:00Z'));
        // const d = new Date();
        const d = authState.curr || new Date();
        setDate(new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0));
        setEntryName(authState.curr_en)
        setClickColor(authState.curr_cc)
        setClickType(authState.curr_ct)
    }, []);
    const handleChange = React.useCallback((newValue) => { setDate(newValue); }, []);
    const handlePN = React.useCallback((delta)=>{
        setDate((cur) => {
            // console.log(cur, delta);
            const x = new Date(cur.getTime());
            x.setMonth(x.getMonth()+delta);
            // console.log(cur, delta);
            return x;
        });
        
    }, []);
    const handlePrev = React.useCallback(() => { handlePN(-1); }, [handlePN]);
    const handleNext = React.useCallback(() => { handlePN(+1); }, [handlePN]);



    // ----------

    const [datas, setDatas] = React.useState({events:[], /*emerge:[], holiday:[],*/ checks:[]});
    const loadDatas = React.useCallback((date) => {
        if (!date) return;

        const e = getEvents(date);
        const c = getChecks(date);

        Promise.all([e, c])
        .then(result => {
            const wk = {events: result[0].data, checks: result[1].data};
            setDatas(wk);
        })
        .catch(()=>{});

    }, [getChecks, getEvents]); 
    const loadDatasDefault = React.useCallback(() => { loadDatas(date); }, [date, loadDatas]);
    React.useEffect(()=>{ loadDatas(date); }, [date, loadDatas]);

    // ----------

    const recvMessage = React.useCallback((message) => {
        // console.log("受信しました");
        const x = JSON.parse(message.data);
        // console.log(x);
        const actionStr = getActionString(x.action);
        if(x.action === "LOGIN" || x.action === "LOGOUT") {
            enqueueSnackbar(`${x.name || '無名'} さんが ${actionStr}`, {variant:'info'});
        } else {
            const wakuStr = getWakuString(x.waku);
            enqueueSnackbar(`${actionStr} [ ${x.date} : ${wakuStr} : ${x.name || '無名'}]`, {variant:'info'});
            loadDatasDefault();
        }
    }, [enqueueSnackbar, loadDatasDefault]);
    const [ sendMessage ] = useCommService({onMessage: recvMessage});

    // React.useEffect(() => {
    //     sendMessage || sendMessage({action: 'LOGIN', name: state.name});
    // }, [sendMessage, state]);

    // ----------

    const [calendar, setCalendar] = React.useState([]);
    const makeCalendar = React.useCallback((date, datas) => {
        if (!date) return;

        const Y = date.getFullYear();
        const M = date.getMonth();

        const days = new Date(Y, M+1, 0, 0, 0, 0).getDate();

        const events = datas.events || [];
        const checks = datas.checks || [];

        // console.log(getDays(date, 4))
        const thu2nd = getDays(date, 4)[1]

        const wk = [];
        for(var i=1; i<=days; i++) {
            const d = new Date(Y, M, i, 0, 0, 0, 0);
            const f = format(d, 'yyyy-MM-dd', {locale: ja});

            const preF = format(new Date(Y, M, i-1, 0, 0, 0, 0), 'yyyy-MM-dd', {locale: ja});

            const dayChecks = checks.filter((c)=>(c.date===f));
            const rChecks = dayChecks.reduce((a, b) =>{
                a[`${b.cell}_${b.type}`] = (a[`${b.cell}_${b.type}`]||0) + 1;
                a[`${b.cell}_${b.color}`] = (a[`${b.cell}_${b.color}`]||0) + 1; // add color
                a[`${b.cell}_memo`] = `${b.memo}`;
                a[`${b.cell}_memo_cmp`] = (entryName && b.memo===entryName) ? "nameMatch" : "";
                return a;
            }, {});

            const v = {
                day: i, date: d, fdate: f,
                weekday: format(d, 'E', {locale: ja}),
                thu2nd: (i===thu2nd?true:false),

                emerge: events.find((v=>(v.date===f && v.type==='emerge'))) ? true : false,
                emergeNext: events.find((v=>(v.date===preF && v.type==='emerge'))) ? true : false,
                holiday: events.find((v=>(v.date===f && v.type==='holiday'))) ? true : false,
                memo: events.find((v=>(v.date===f && v.type==='memo')))?.memo || '',
                ...rChecks,
            };
            wk.push(v);
        }
        setCalendar(wk);
    }, [entryName]);
    React.useEffect(()=>{ makeCalendar(date, datas); }, [date, datas, makeCalendar]);


    React.useEffect(() => {
        const updateTableHeight = () => {
            if (appBarRef.current && tableWrapRef.current) {
                const appBarHeight = appBarRef.current.offsetHeight;
                tableWrapRef.current.style.height = `calc(100vh - ${appBarHeight+20}px)`;
                // console.log(appBarHeight);
            }
        };

        updateTableHeight();
        window.addEventListener('resize', updateTableHeight);

        return () => {
            window.removeEventListener('resize', updateTableHeight);
        };
    }, [calendar]); 
    

    // ----------

    const [clickType, setClickType] = React.useState('normal');
    const handleClickType = React.useCallback((e) => {
        setClickType(e.target.value);
    }, [setClickType]);

    const [clickColor, setClickColor] = React.useState('c1');
    const handleClickColor = React.useCallback((e) => {
        setClickColor(e.target.value);
    }, [setClickColor]);

    // ----------

    const dayConfigDialog = React.useRef();
    const handleClickDay = React.useCallback((item) => {
        dayConfigDialog.current.openDialog(item);
    }, []);

    // const dayEventLogDialog = React.useRef();
    // const handleRClickDay1 = React.useCallback((item) => {
    //     dayEventLogDialog.current.openDialog(item);
    // }, []);

    const dayCheckLogDialog = React.useRef();
    const handleRClickWaku = React.useCallback((item, waku) => {
        dayCheckLogDialog.current.openDialog(item, waku);
    }, []);

    const calcDialog = React.useRef();
    const handleRClickDay = React.useCallback((item) => {
        calcDialog.current.openDialog(item);
    }, []);
    // const helpDialog = React.useRef();
    // const handleRClickWaku2 = React.useCallback(() => {
    //     helpDialog.current.openDialog();
    // }, []);

    // ----------

    const handleClickWaku = React.useCallback((item, waku) => {
        if(handleClickWakuF) return;
        handleClickWakuF = true;

        const cnt_close  = item[`${waku}_close`] || 0;
        if(clickType==='close') {
            if(cnt_close>0) {
                wakuOpen(item.date, waku, authState)
                .then(()=>{
                    // enqueueSnackbar('OPEN ' + waku, {variant:'info'});
                    sendMessage({action: 'OPEN', waku, date: item.fdate, name: authState.name});
                    // loadDatas(date);
                })
                .catch(()=>{})
                .finally(()=>{handleClickWakuF=false;});
                return;
            } else {
                wakuClose(item.date, waku, authState)
                .then(()=>{
                    // enqueueSnackbar('CLOSE ' + waku, {variant:'info'});
                    sendMessage({action: 'CLOSE', waku, date:item.fdate, name: authState.name});
                    // loadDatas(date);
                })
                .catch(()=>{})
                .finally(()=>{handleClickWakuF=false;});
                return;
            }
        }

        const cnt_normal  = item[`${waku}_check`] || 0;
        const cnt_dock    = item[`${waku}_dock`] || 0;
        const cnt_special = item[`${waku}_special`] || 0; /* 20241031 */
        const cnt_asbestos = item[`${waku}_asbestos`] || 0; /* 20250122 */
        // const cnt_red    = item[`${waku}_checkRed`] || 0;
        if(cnt_normal+cnt_dock+cnt_special+cnt_asbestos > 1) { /* 20241031 20250122 */
        // if(cnt_normal+cnt_red > 1) {
            enqueueSnackbar('OVER COUNTS', {variant:'error'});
            // webSocketRef.current?.send(JSON.stringify(item));
            if(window.confirm("重複をリセットしますか？")) {
                wakuUncheck(item.date, waku, 'normal', authState);
                // wakuUncheck(item.date, waku, 'red');
                wakuUncheck(item.date, waku, 'dock', authState);
                wakuUncheck(item.date, waku, 'special', authState); /* 20241031 */
                wakuUncheck(item.date, waku, 'asbestos', authState); /* 20250122 */
                sendMessage({action: 'RESET', waku, date:item.fdate, name: authState.name});
            }
            // sendMessage(item);
            // alert("OVER COUNTS");
            handleClickWakuF=false;
            return;
        }

        if((cnt_normal===1 && clickType!=='normal') || (cnt_dock===1 && clickType!=='dock') || (cnt_special===1 && clickType!=='special') || (cnt_asbestos===1 && clickType!=='asbestos')) { /* 20241031 20250122 */
        // if((cnt_normal === 1 && clickType==='dock') || (cnt_dock === 1 && clickType==='normal')) { /* 20241031 */
        // if((cnt_normal === 1 && clickType==='red') || (cnt_red === 1 && clickType==='normal')) {
                enqueueSnackbar('削除対象と処理対象が異なります。チェックの色を確認してください。', {variant:'error', vertical: 'top', horizontal: 'center',});
            handleClickWakuF=false;
            return;
        }

        if(cnt_normal+cnt_dock+cnt_special+cnt_asbestos === 1) { /* 20241031 20250122 */
            if(!window.confirm("解除してもよろしいですか？")) {
                handleClickWakuF=false;
                return;
            }
        // if(cnt_normal+cnt_red === 1) {
            wakuUncheck(item.date, waku, clickType, authState)
            .then(()=>{
                // enqueueSnackbar('unCHECK' + clickType, {variant:'info'});
                sendMessage({action: 'UNCHECK', waku, date:item.fdate, name: authState.name});
                // loadDatas(date);
                // sendMessage(item);
            })
            .catch(()=>{})
            .finally(()=>{handleClickWakuF=false;});
            return;
        } else {
            var memo='';
            // if (waku[0]==='I') {
            if(entryName) {
                memo = entryName
            } else {
                memo = prompt('名前を入力してください');
            }
            // }
            wakuCheck(item.date, waku, clickType, clickColor, memo, authState)
            .then(()=>{
                // enqueueSnackbar('CHECK' + clickType, {variant:'info'});
                sendMessage({action: 'CHECK', waku, date:item.fdate, name: authState.name});
                // loadDatas(date);
                // sendMessage(item);
            })
            .catch(()=>{})
            .finally(()=>{handleClickWakuF=false;});
            return;
        }

    }, [clickType, clickColor, enqueueSnackbar, sendMessage, wakuOpen, wakuClose, wakuUncheck, wakuCheck, authState, /*date, loadDatas,*/ entryName]);

    const handleReloadButtonClick = React.useCallback((event) => {
        loadDatasDefault();
    }, [loadDatasDefault]);
    // ----------

    const handlePersonButton = React.useCallback(() => {
        setEntryName((n)=>prompt("名前を入力してください", n))
    }, [])
    const handlePersonClearButton = React.useCallback(() => {
        if(window.confirm("対象者名をクリアします。よろしいですか？"))
            setEntryName("")
    }, [])

    // ----------

    const DY = format(date||new Date(), 'yyyy', {locale: ja});
    const DM = format(date||new Date(), 'MM', {locale: ja});


    const [ anchorMenu, setAnchorMenu ] = React.useState(null);
    const openMenu = Boolean(anchorMenu);

    const handleMenuOpen = React.useCallback((e) => { setAnchorMenu(e.currentTarget); }, []);
    const handleMenuClose = React.useCallback(() => { setAnchorMenu(null); }, []);

    const passwordDialog = React.useRef();

    const menuLogout = React.useCallback(() => { logoff(); }, [logoff]);
    const menuMaster = React.useCallback(() => { modeMaster(); }, [modeMaster]);
    const menuPassword = React.useCallback(() => { passwordDialog.current.modifyPassword(authState); }, [authState]);

    const handlePrint = React.useCallback(()=>{ window.print() }, []);

    const helpDialog = React.useRef();
    const handleHelp = React.useCallback(()=>{ helpDialog.current.openDialog(); }, []);

    const handleAm = React.useCallback(() => { modeAm(date, entryName, clickColor, clickType); }, [modeAm]);
    const handlePm = React.useCallback(() => { modePm(date, entryName, clickColor, clickType); }, [modePm]);

    return (<Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" className="noPrint" ref={appBarRef}>
            <Toolbar>
                {/* <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
            >
                <MenuIcon />
            </IconButton> */}
                <Typography variant="h6" component="div">
                    健診予約表
                </Typography>

                <IconButton size="large" color="inherit" onClick={handleReloadButtonClick} title="再読込" >
                    <Cached />
                </IconButton>
                <Button variant="contained"color="success" onClick={handleAm}>AMへ</Button>
                <Button variant="contained"color="success" onClick={handlePm}>PMへ</Button>

                <Divider orientation="vertical" flexItem sx={{ flexGrow: 1 }} />

                <Box>
                <Box className="nowrap">
                <IconButton size="large" color="inherit" onClick={handlePrev} title="前月" >
                    <ArrowCircleLeft />
                </IconButton>

                <DatePicker
                    views={['year','month'/*,'year'*/]}
                    openTo={'month'}
                    value={date}
                    onChange={handleChange}
                    inputFormat='yyyy/MM'
                    minDate={new Date('2020/01/01 00:00:00')}
                    renderInput={(params) => <TextField {...params} variant="standard" helperText={null} />}
                    InputProps={{ readOnly: true, sx: { "& .MuiSvgIcon-root": { color: "white" }, "& .MuiInputBase-input": { color: "white", width: "80px" } } }}
                />
                <IconButton size="large" color="inherit" onClick={handleNext} title="次月" >
                    <ArrowCircleRight />
                </IconButton>

                </Box>
                <Box>
                    <span className="nowrap">
                    <IconButton size="large" color="inherit" onClick={handlePersonButton} title="対象者" >
                        <Person />
                    </IconButton>
                    <TextField value={entryName} inputProps={{readOnly: true, sx: { "&.MuiInputBase-input": { color: "white" } }}} variant='standard' /*label="登録氏名" color='info'*/ />
                    </span>
                    <IconButton size="large" color="inherit" onClick={handlePersonClearButton} title="クリア" >
                        <Clear />
                    </IconButton>
                </Box>
                </Box>

                <Divider orientation="vertical" flexItem sx={{ flexGrow: 1 }} />

                <FormControl>
                    <RadioGroup row name='check_color' onChange={handleClickColor} value={clickColor}>
                        <FormControlLabel value='c1' control={<Radio color="default"/>} label={<span className='colorSel c1'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        <FormControlLabel value='c2' control={<Radio color="default"/>} label={<span className='colorSel c2'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        <FormControlLabel value='c3' control={<Radio color="default"/>} label={<span className='colorSel c3'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        <FormControlLabel value='c4' control={<Radio color="default"/>} label={<span className='colorSel c4'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        <FormControlLabel value='c5' control={<Radio color="default"/>} label={<span className='colorSel c5'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        <FormControlLabel value='c6' control={<Radio color="default"/>} label={<span className='colorSel c6'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        <FormControlLabel value='c7' control={<Radio color="default"/>} label={<span className='colorSel c7'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        <FormControlLabel value='c8' control={<Radio color="default"/>} label={<span className='colorSel c8'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>

                        <FormControlLabel value='c9' control={<Radio color="default"/>} label={<span className='colorSel c9'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        <FormControlLabel value='ca' control={<Radio color="default"/>} label={<span className='colorSel ca'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        <FormControlLabel value='cb' control={<Radio color="default"/>} label={<span className='colorSel cb'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        <FormControlLabel value='cc' control={<Radio color="default"/>} label={<span className='colorSel cc'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>

                        <FormControlLabel value='cd' control={<Radio color="default"/>} label={<span className='colorSel cd'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        {/* <FormControlLabel value='ce' control={<Radio color="default"/>} label={<span className='colorSel ce'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/> */}
                        {/* <FormControlLabel value='cf' control={<Radio color="default"/>} label={<span className='colorSel cf'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/> */}
                        {/* <FormControlLabel value='cg' control={<Radio color="default"/>} label={<span className='colorSel cg'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/> */}
                        <FormControlLabel value='ch' control={<Radio color="default"/>} label={<span className='colorSel ch'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        <FormControlLabel value='ci' control={<Radio color="default"/>} label={<span className='colorSel ci'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/>
                        {/* <FormControlLabel value='cj' control={<Radio color="default"/>} label={<span className='colorSel cj'>　</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "white" }}}/> */}
                    </RadioGroup>
                </FormControl>

                <Divider orientation="vertical" flexItem />

                <FormControl>
                    <RadioGroup row name='check_type' onChange={handleClickType} value={clickType}>
                        <FormControlLabel value='normal' control={<Radio color="default"/>} label={<span className='check'>✔</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "Orange" }}}/>
                        {/* <FormControlLabel value='red' control={<Radio color="default"/>} label={<span className='check redcheck'>✔</span>} /> */}
                        <FormControlLabel value='dock' control={<Radio color="default"/>} label={<span className='check'>ド</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "Orange" }}}/>
                        <FormControlLabel value='special' control={<Radio color="default"/>} label={<span className='check'>特</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "Orange" }}}/>
                        <FormControlLabel value='asbestos' control={<Radio color="default"/>} label={<span className='check'>ア</span>}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "Orange" }}}/>
                        <FormControlLabel value='close' control={<Radio color="default"/>} label={'枠閉'}  labelPlacement="bottom" sx={{"& .MuiSvgIcon-root": { color: "Orange" }}}/>
                        {/* <FormControlLabel value='open' control={<Radio color="default"/>} label={'open'}  labelPlacement="bottom"/> */}
                    </RadioGroup>
                </FormControl>

                <Divider orientation="vertical" flexItem  />
                <IconButton size="large" color="inherit" onClick={handleHelp} title="項目一覧" >
                    <Help />
                </IconButton>
                <IconButton size="large" color="inherit" onClick={handlePrint} title="印刷" >
                    <Print />
                </IconButton>
                <Divider orientation="vertical" flexItem  />

                <IconButton size="large" color="inherit" onClick={handleMenuOpen} title="アカウント"
                    aria-label="account of current user"
                    aria-controls={openMenu ? 'basic-menu' : undefined}
                    aria-expanded={openMenu ? 'true' : undefined}
                    aria-haspopup="true"
                >
                    <AccountCircle />
                </IconButton>
                <Menu
                    anchorEl={anchorMenu}
                    open={openMenu}
                    onClose={handleMenuClose}
                    MenuListProps={{ 'aria-labelledby': 'basic-button', }}
                >
                    <MenuItem onClick={menuLogout}>ログアウト</MenuItem>
                    <Divider/>
                    <MenuItem onClick={menuPassword} disabled={authState.code==='system'}>パスワード変更</MenuItem>
                    <Divider/>
                    <MenuItem onClick={menuMaster} disabled={authState.auth!=='admin'}>アカウント管理</MenuItem>
                </Menu>
                {authState.name}
            </Toolbar>
        </AppBar>

        { (!calendar || calendar.length<=0) ? <h2>NO DATA</h2> : <>
        <div className='table-wrap' ref={tableWrapRef}><table className='reserveTable'>
            <thead>
                <tr>
                    <th colSpan='2' rowSpan='3' className='tateL'>{DY}<br/>{DM}月</th>

                    <th colSpan='8' className='tateL'>{asbestosHeader(date)}</th>
                    <th colSpan='5' className='tateL'>5 名</th>

                    <th colSpan='2' rowSpan='3' className='tateL tateR'>{DY}<br/>{DM}月</th>
                </tr>
                <tr>
                    <th colSpan='8' className='bbc tateL'>診察</th>
                    <th colSpan='5' className='bbc tateL'>職員</th>
                </tr>
                <tr>
                    <th colSpan='8' className='btc tateL small_1'><span className='attention mini'>アスベスト含む (月・金は労安2件まで)<br/>CT合わせて5名まで (月・金優先で)</span></th>
                    {/* <th colSpan='5' className='bbc'>アスベスト 5枠</th> */}
                    <th colSpan='7' className='btc tateL'>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                { calendar.map(item => ( <ReserveTableRow  key={item.fdate} item={item} onClickDay={handleClickDay} onClickWaku={handleClickWaku} onRClickDay={handleRClickDay} onRClickWaku={handleRClickWaku}/> ))}
            </tbody>
        </table></div>
        <DayConfigDialog onChange={loadDatasDefault} ref={dayConfigDialog}/>
        <DayCheckLogDialog ref={dayCheckLogDialog}/>
        {/* <DayEventLogDialog ref={dayEventLogDialog}/> */}
        <PasswordDialog ref={passwordDialog}/>
        <CalcDialog ref={calcDialog}/>
        <HelpDialog ref={helpDialog}/>
        </>}
    </Box>)
}

// ==========
const ReserveTableRowTd = ({waku, item, onClickWaku, onRClickWaku, closeFuncs, /*closeFunc1, closeFunc2,*/ addClassName}) => {
    const className = React.useMemo(() => {
        const wk = (closeFuncs||[]).map((func)=>func(item));
        wk.push(valClose(item, waku));
        if(addClassName) wk.push(addClassName);
        if(item[`${waku}_memo_cmp`]) wk.push(item[`${waku}_memo_cmp`]);
        return wk.join(' ');
        // return [
        //     closeFunc1 ? closeFunc1(item) : null,
        //     closeFunc2 ? closeFunc2(item) : null,
        //     valClose ? valClose(item, waku) : null,
        //     addClassName ? addClassName : null,
        // ].join(' ');
    }, [item, waku, closeFuncs, /*closeFunc1, closeFunc2,*/ addClassName]);

    const handleClickWaku = React.useCallback((e) => {
        // console.log(e);
        e.preventDefault();
        onClickWaku(item, waku);
    }, [item, waku, onClickWaku]);

    const handleRClickWaku = React.useCallback((e) => {
        // console.log(e);
        e.preventDefault();
        onRClickWaku(item, waku);
    }, [item, waku, onRClickWaku]);

    const format = React.useMemo(() => valCheck(item, waku), [item, waku]);

    return (
        <td className={className} onClick={handleClickWaku} onContextMenu={handleRClickWaku}>{format}</td>
    );
}


const ReserveTableRow = ({item, onClickDay, onClickWaku, onRClickDay, onRClickWaku}) => {
    const handleClickDay = React.useCallback(() => {
        onClickDay(item);
    }, [item, onClickDay]);
    
    const handleRClickDay = React.useCallback((e) => {
        e.preventDefault();
        onRClickDay(item);
    }, [item, onRClickDay]);

    // const handleClickWaku = React.useCallback((waku) => {
    //     onClickWaku(item, waku);
    // }, [item, onClickWaku]);

    const midashi = React.useMemo(()=>({
        className1: weekdayColor(item)+' tateL',
        className2: weekdayColor(item),
        className3: weekdayColor(item)+' tateL',
        className4: weekdayColor(item)+' tateR',
    }), [item]);

    const memoCn = item.memo ? ' memo' : '';

    return (
        <tr title={item.memo}>
            <td className={midashi.className1 + memoCn} onClick={handleClickDay} onContextMenu={handleRClickDay}><div>{item.day}</div></td>
            <td className={midashi.className2} onClick={handleClickDay} onContextMenu={handleRClickDay}>{item.weekday}</td>

            { /* 診察 */ }
            <ReserveTableRowTd waku='V11' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, asbestosTWOpen3]} addClassName='tateL'/>
            <ReserveTableRowTd waku='V12' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, asbestosOpen3a]}/>
            <ReserveTableRowTd waku='V13' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, asbestosOpen3a]}/>
            <ReserveTableRowTd waku='V14' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, asbestosOpen3, thuClose]}/>
            <ReserveTableRowTd waku='V15' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, asbestosOpen3, thuClose]}/>
            <ReserveTableRowTd waku='V16' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, thuClose]}/>
            <ReserveTableRowTd waku='V17' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, asbestosTWOpen, thuClose]}/>
            <ReserveTableRowTd waku='V18' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, asbestosTWOpen, thuClose]}/>

            { /* アスベスト */ }
            {/* <ReserveTableRowTd waku='V21' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, thuClose, asbestosOpen]} addClassName='green'/> */}
            {/* <ReserveTableRowTd waku='V22' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, thuClose, asbestosOpen]} addClassName='green'/> */}
            {/* <ReserveTableRowTd waku='V23' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, thuClose, asbestosOpen]} addClassName='green'/> */}
            {/* <ReserveTableRowTd waku='V24' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, thuClose, asbestosOpen]} addClassName='green'/> */}
            {/* <ReserveTableRowTd waku='V25' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose, thuClose, asbestosOpen]} addClassName='green'/> */}

            { /* 職員 */ }
            <ReserveTableRowTd waku='W01' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose]} addClassName='tateL'/>
            <ReserveTableRowTd waku='W02' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose]}/>
            <ReserveTableRowTd waku='W03' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose]}/>
            <ReserveTableRowTd waku='W04' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose]}/>
            <ReserveTableRowTd waku='W05' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose]}/>
            {/* <ReserveTableRowTd waku='W06' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose]}/> */}
            {/* <ReserveTableRowTd waku='W07' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose]}/> */}
            {/* <ReserveTableRowTd waku='W08' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose]}/> */}
            {/* <ReserveTableRowTd waku='W09' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose]}/> */}
            {/* <ReserveTableRowTd waku='W0A' item={item} onClickWaku={onClickWaku} onRClickWaku={onRClickWaku} closeFuncs={[weekdayClose]}/> */}

            <td className={midashi.className3} onClick={handleClickDay} onContextMenu={handleRClickDay}>{item.day}</td>
            <td className={midashi.className4} onClick={handleClickDay} onContextMenu={handleRClickDay}>{item.weekday}</td>
        </tr>
    );
}

export default ReserveTale;

// ==========

const DayConfigDialog = React.forwardRef((props, ref) => {
    const { onChange } = props;

    const { updateHoliday, updateEmerge, updateMemo } = useAjax();
    const { state:authState } = useAuth();

    const [curItem, setCurItem] = React.useState(null);
    const [item, setItem] = React.useState(null);
    const handleChangeCheck = React.useCallback((e) => { setItem((item)=>({...item, [e.target.name]: e.target.checked})); }, []);

    // const [memo, setMemo] = React.useState('');
    const handleChange = React.useCallback((e) => { setItem((item) => ({...item, [e.target.name]: e.target.value})) }, [])

    const openDialog = React.useCallback((item) => { setCurItem(item); setItem(item); }, []);
    const handleClose = React.useCallback(() => { setItem(null); setCurItem(null); }, []);
    const handleUpdate = React.useCallback((()=>{
        const promises = [];

        if(curItem?.holiday!==item?.holiday) {
            promises.push(updateHoliday(item.date, item.holiday, authState));
        }
        if(curItem?.emerge!==item?.emerge) {
            promises.push(updateEmerge(item.date, item.emerge, authState));
        }
        if(curItem?.memo!==item?.memo) {
            promises.push(updateMemo(item.date, item.memo, authState));
        }

        Promise.all(promises)
        .then(() => {
            if(onChange) onChange();
            handleClose();
        })
        .catch((e) => {
            console.error(e);
        });

    }), [onChange, handleClose, curItem, item, updateHoliday, updateEmerge, updateMemo, authState]);

    const disabled = React.useMemo(()=>(curItem?.holiday===item?.holiday && curItem?.emerge===item?.emerge && curItem?.memo===item?.memo), [item, curItem]);
    const isOpen = React.useMemo(()=>(item?true:false), [item]);

    const dayEventLogDialog = React.useRef();
    const handleHistory = React.useCallback(() => {
        dayEventLogDialog.current.openDialog(item);
    }, [item]);

    React.useImperativeHandle(ref, () => ({ openDialog, }));

    if (!isOpen) return null;
    return (
        <Dialog onClose={handleClose} open={isOpen} fullWidth={true} maxWidth='xs'>
            <DialogTitle>
                {item.fdate}
                &nbsp;
                <Button onClick={handleHistory} variant="contained">履歴</Button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    休日設定、救急日設定を確認してください。
                </DialogContentText>
                <FormGroup>
                    <FormControlLabel control={<Switch name='holiday' checked={item.holiday} onChange={handleChangeCheck}/>} label='祝日'/>
                    <FormControlLabel control={<Switch name='emerge' checked={item.emerge} onChange={handleChangeCheck}/>} label='救急'/>
                </FormGroup>
                <br/>
                <DialogContentText>
                    備考欄：共有する為の補足情報を記載してください。
                </DialogContentText>
                <TextField multiline rows={6} fullWidth value={item.memo} name='memo' onChange={handleChange}/>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleUpdate} variant="contained" disabled={disabled}>OK</Button>
                <Button onClick={handleClose} variant="outlined">Cancel</Button>
            </DialogActions>
            <DayEventLogDialog ref={dayEventLogDialog}/>
        </Dialog>
    )
});

// const getWakuName = (waku) => {
//     switch(waku[0]) {
//         case 'A': return "診察";
//         case 'B': return "MgX-P";
//         case 'C': return "胃カメラ";
//         case 'D': return "胃単独";
//         case 'E': return "胃検査なし";
//         case 'F': return "特定健診";
//         case 'G': return "エコー";
//         case 'H': return "子宮がん検診";
//         case 'I': return "乳がん検診";
//         case 'J': return "心臓ドック";
//         case 'K': return "脳ドック";
//         default: return "-";
//     }
// }

const DayCheckLogDialog = React.forwardRef((props, ref) => {
    const { getCheckHist } = useAjax();
    const [item, setItem] = React.useState(null);
    const [waku, setWaku] = React.useState(null);
    const [data, setData] = React.useState([]);

    const openDialog = React.useCallback((item, waku) => { setItem(item); setWaku(waku); }, []);
    const handleClose = React.useCallback(() => { setItem(null); setWaku(null); setData([]); }, []);

    const isOpen = React.useMemo(()=>(item?true:false), [item]);

    React.useImperativeHandle(ref, () => ({ openDialog, }));

    React.useEffect(()=>{
        if(!item) return;
        // console.log(item, waku);
        getCheckHist(item.date, waku)
        .then(result=>{
            console.log(result.data);
            setData(result.data);
        })
        .catch(()=>{});
    }, [item, waku, getCheckHist]);

    if (!isOpen) return null;

    const wakuName = getWakuString(waku);
    return (
        <Dialog onClose={handleClose} open={isOpen} fullWidth={true} maxWidth='xs'>
            <DialogTitle>{item.fdate} : {wakuName}({waku})</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    操作履歴：チェック
                </DialogContentText>
                <table className='historyTable'>
                    {/* <caption>履歴</caption> */}
                    <thead>
                        <tr>
                            {/* <th>id</th> */}
                            {/* <th>date</th> */}
                            {/* <th>cell</th> */}
                            <th>値{/*type*/}</th>
                            {/* <th>color</th> */}
                            {/* <th>memo</th> */}
                            <th>作成{/*created_at*/}</th>
                            {/* <th>created_by</th> */}
                            <th>編集{/*updated_at*/}</th>
                            {/* <th>updated_by</th> */}
                            <th>削除{/*delete_at*/}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((obj)=>{
                            // const mark = obj.type==='check'?obj.memo||'✔': obj.type!=='close'?'ド':'閉';
                            // const mark = obj.type==='check'?'✔': obj.type!=='close'?'ド':'閉';
                            const mark = obj.type==='check'?'✔': obj.type==='close'?'閉' : obj.type==='dock'?'ド' : obj.type==='special'?'特':'ア';
                            return <tr key={obj.id}>
                                {/* <td>{obj.id}</td> */}
                                {/* <td>{obj.date}</td> */}
                                {/* <td>{obj.cell}</td> */}
                                <td><span className={`check ${obj.color}`}>{mark/*obj.type*/}</span><br/>{obj.memo}</td>
                                {/* <td>{obj.color}</td> */}
                                {/* <td>{obj.memo}</td> */}
                                <td>{obj.created_at}<br/>{obj.created_by}</td>
                                {/* <td>{obj.created_by}</td> */}
                                <td>{(obj.updated_by)?<>{obj.updated_at}<br/>{obj.updated_by}</>:' '}</td>
                                {/* <td>{obj.updated_by}</td> */}
                                <td>{(obj.delete_at)?'削除':' '}</td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="outlined">Cancel</Button>
            </DialogActions>
        </Dialog>
    )
});

const DayEventLogDialog = React.forwardRef((props, ref) => {
    const { getEventHist } = useAjax();
    const [item, setItem] = React.useState(null);
    const [data, setData] = React.useState([]);

    const openDialog = React.useCallback((item) => { setItem(item); }, []);
    const handleClose = React.useCallback(() => { setItem(null); }, []);

    const isOpen = React.useMemo(()=>(item?true:false), [item]);

    React.useImperativeHandle(ref, () => ({ openDialog, }));

    React.useEffect(()=>{
        if(!item) return;
        // console.log(item);
        getEventHist(item.date)
        .then(result=>{
            // console.log(result.data);
            setData(result.data);
        })
        .catch(()=>{});
    }, [item, getEventHist]);

    if (!isOpen) return null;

    return (
        <Dialog onClose={handleClose} open={isOpen} fullWidth={true} maxWidth='sm'>
            <DialogTitle>{item.fdate}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    操作履歴：イベント
                </DialogContentText>
                <table className='historyTable'>
                    {/* <caption>履歴</caption> */}
                    <thead>
                        <tr>
                            {/* <th>id</th> */}
                            {/* <th>date</th> */}
                            {/* <th>cell</th> */}
                            <th>種類{/*type*/}</th>
                            {/* <th>color</th> */}
                            <th>備考</th>
                            <th>作成{/*created_at*/}</th>
                            {/* <th>created_by</th> */}
                            <th>編集{/*updated_at*/}</th>
                            {/* <th>updated_by</th> */}
                            <th>削除{/*delete_at*/}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((obj)=>{
                            const type = obj.type==='holiday'?'祝日': obj.type==='emerge'?'救急':'備考';
                            return <tr key={obj.id}>
                                {/* <td>{obj.id}</td> */}
                                {/* <td>{obj.date}</td> */}
                                {/* <td>{obj.cell}</td> */}
                                <td>{type}</td>
                                {/* <td>{obj.color}</td> */}
                                <td>{obj.memo}</td>
                                <td>{obj.created_at}<br/>{obj.created_by}</td>
                                {/* <td>{obj.created_by}</td> */}
                                <td>{(obj.updated_by)?<>{obj.updated_at}<br/>{obj.updated_by}</>:' '}</td>
                                {/* <td>{obj.updated_by}</td> */}
                                <td>{(obj.delete_at)?'削除':' '}</td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="outlined">Cancel</Button>
            </DialogActions>
        </Dialog>
    )
});

const CalcList = ['V21', 'V22', 'V23', 'V24', 'V25', 'V31', 'V32', 'V11', 'V12', 'V13', 'V14', 'V15', 'V16', 'V17', 'V18', 'V19', 'V1A', 'V1B', 'V1C', 'V1D']
const CalcDialog = React.forwardRef((props, ref) => {
    // const { getEventHist } = useAjax();
    const [item, setItem] = React.useState(null);
    // const [data, setData] = React.useState([]);
    const [check, setCheck] = React.useState(0);
    const [dock, setDock] = React.useState(0);
    const [special, setSpecial] = React.useState(0);
    const [asbestos, setAsbestos] = React.useState(0);

    const openDialog = React.useCallback((item) => { setItem(item); }, []);
    const handleClose = React.useCallback(() => { setItem(null); }, []);

    const isOpen = React.useMemo(()=>(item?true:false), [item]);

    React.useImperativeHandle(ref, () => ({ openDialog, }));

    // React.useEffect(()=>{
        // if(!item) return;
        // // console.log(item);
        // getEventHist(item.date)
        // .then(result=>{
        //     // console.log(result.data);
        //     setData(result.data);
        // })
        // .catch(()=>{});
    // }, [item, getEventHist]);
    React.useEffect(()=>{
        console.log(item)
    }, [item, ]);
    React.useEffect(()=>{
        if(!item)return;
        setCheck(CalcList.map(v=>(item[`${v}_check`] || 0)).reduce((a,b)=>a+b))
        setDock(CalcList.map(v=>(item[`${v}_dock`] || 0)).reduce((a,b)=>a+b))
        setSpecial(CalcList.map(v=>(item[`${v}_special`] || 0)).reduce((a,b)=>a+b))
        setAsbestos(CalcList.map(v=>(item[`${v}_asbestos`] || 0)).reduce((a,b)=>a+b)) /* 20250122 */
        // CalcList.map(v=>item[`${v}_dock`])
        // CalcList.map(v=>item[`${v}_special`])
        console.log(item)
    }, [item, ]);

    if (!isOpen) return null;

    return (
        <Dialog onClose={handleClose} open={isOpen} fullWidth={true} maxWidth='sm'>
            <DialogTitle>{item.fdate}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    集計：診察
                </DialogContentText>
                <table className='historyTable'>
                    {/* <caption>履歴</caption> */}
                    <thead>
                        <tr>
                            <th>一般</th>
                            <th>ドック</th>
                            <th>特定健診</th>
                            <th>アスベスト</th>
                            <th>計</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{check}</td>
                            <td>{dock}</td>
                            <td>{special}</td>
                            <td>{asbestos}</td>
                            <td>{check+dock+special+asbestos}</td>
                        </tr>
                    </tbody>
                </table>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="outlined">Cancel</Button>
            </DialogActions>
        </Dialog>
    )
});

const HelpDialog = React.forwardRef((props, ref) => {
    const [item, setItem] = React.useState(false);
    // const [data, setData] = React.useState([]);

    const openDialog = React.useCallback(() => { setItem(true); }, []);
    const handleClose = React.useCallback(() => { setItem(false); }, []);

    const isOpen = React.useMemo(()=>(item), [item]);

    React.useImperativeHandle(ref, () => ({ openDialog, }));

    // React.useEffect(()=>{
        // if(!item) return;
        // // console.log(item);
        // getEventHist(item.date)
        // .then(result=>{
        //     // console.log(result.data);
        //     setData(result.data);
        // })
        // .catch(()=>{});
    // }, [item, getEventHist]);

    if (!isOpen) return null;

    return (
        <Dialog onClose={handleClose} open={isOpen} fullWidth={true} maxWidth='sm'>
            <DialogTitle>{item.fdate}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <h2>※注意事項</h2>
                    <ul>
                        <li>アスベスト含む (月・金は労安2件まで)</li>
                        <li>CT合わせて5名まで (月・金優先で)</li>
                        <li>CTは月・金のみ(1日1名まで)</li>
                    </ul>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="outlined">Cancel</Button>
            </DialogActions>
        </Dialog>
    )
});
